module.exports = __webpack_public_path__ + "media/images/landing/persons/dominika-dragunova-b1a1be46eacf3858378f330f7a6e3f52.jpg";